import { useState } from "react";
import { useAuth } from "./Utils/Auth";
import { useNavigate } from "react-router-dom";
import "./Css/Login.css"
import axios from "axios";



export default function Login() 
{
    const [errors, setErrors] = useState({});
    const [user,setUser] = useState({pass:""});
    const auth = useAuth();
    const navigate = useNavigate();
    
    const handleChange = (e) =>{
        setUser(prev=>({...prev, [e.target.name]: e.target.value }));
      }

    const SignIn = async e => {
        e.preventDefault();
        const newErrors = validateForm(user);
        setErrors(newErrors);
        if (Object.keys(newErrors).length === 0) {
            const result = await axios.post("https://mariage-bs.ch:4006/login",user);
            if (result.data.isLogged ) {
                auth.login(user,result.data.isAdmin);
                navigate('/');     
            } 
            else
            {
                const errorLogin = {};
                errorLogin.incorrect = "Le mot de passe est incorrect";
                setErrors(errorLogin);
            }
        }
    }
    
    const validateForm = (pass) =>{
        const errors = {};
        if (pass === "" || pass === undefined) {
            errors.pass= "Veuillez entrer le mot de passe";
        }

        return errors;
    }

    return(
        <>
            
            <div className="login-container">
                <div className="bienvenu">
                    <div className="bienvenue-titre"> Bienvenue</div>
                    <img className="bienvenue-logo" src="./Images/Icons/sunflower-icon-2.png" alt="tournesol"></img>
                </div>
                <div className="login-indic">
                    Veuillez entrer le mot de passe afin d'accéder au site
                </div>
                <form>
                    <label>Mot de passe</label>
                    <input className="txt-pass" type="text" name="pass" maxLength="100" onChange={handleChange}/>
                    {errors.pass && (
                        <p className="error-message">
                            {errors.pass}
                        </p>
                    )}
                    {errors.incorrect && (
                        <p className="error-message">
                            {errors.incorrect}
                        </p>
                    )}
                    <input type="submit" onClick={SignIn} value="Connexion"></input>
                </form>
            </div>
        </>
        
    )
}